import React, { Component } from "react";
import styled from "styled-components";
import {withRouter} from 'react-router-dom';
import instructionSheets from "../data/instructionSheets.js";



class Login extends Component {
constructor(props) {
    super(props);
	this.state = {taskUserIdTemp:""}

	this.handleSubmitTaskUserId = this.handleSubmitTaskUserId.bind(this);
	this.handleChangeTaskUserId = this.handleChangeTaskUserId.bind(this);	
}	
	// task-user id to move to App.js
handleChangeTaskUserId = (event) =>{
	this.setState({
		taskUserIdTemp: event.target.value
	})
}

//leveling up taskUserId to App
handleSubmitTaskUserId (event) {
	event.preventDefault();
	this.props.onSubmitTaskUserId(this.state.taskUserIdTemp)
	
	// move to Align page
	this.props.history.push('/align')
}	
	
	

 render() {
	 
	 return (
	<div>
		<Containter>
		<h2> Insert here your HIT token </h2>
		<form onSubmit={this.handleSubmitTaskUserId}>				
			<input name= "taskId" onChange={this.handleChangeTaskUserId} type="text" />
			<button type="submit">Submit</button>
		</form>
		
		</Containter>
	 
	  <br />
		<InstructionContainer>
			<b>List of tokens</b>
			<p>
				Dear Guest,  <br/>
				Insert one of the tokens below to start working in the app. <br/>
				Each token will display a different task. 
				 
			</p>
			<ul>
				{['Demo01', 'Demo02','Demo03', 'Demo04','Demo05', 'Demo06','Demo07', 'Demo08','Demo09', 'Demo10', ].map((token)=> 
					<li>{token}</li>
				)}
			</ul>
			
		</InstructionContainer>
	</div>
	 )
	}	
}

export default withRouter(Login);


const Containter = styled.div`
  display: flex;
  flex-direction: column;
`;


const InstructionContainer = styled.div`
display: grid;
grid-area: instruction;
font-size: smaller;
background-color: white;
width: 80%;
overflow: auto;
text-align: left;
align-items: right;
margin-left: 10%; //place the instructions in the middle of the page horizontally
`;